import { useTexture, TransformControls, Text } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import React, { useRef, useMemo } from 'react';

export default function UVCheckerPlane({ modelSize, modelDimensionZ }) {
    const originalTexture = useTexture('./textures/UVChecker.png');
    const groupRef = useRef();

    const {camera, gl} = useThree();

    const texture = useMemo(() => {
        const clonedTexture = originalTexture.clone();
        clonedTexture.repeat.set(1, 1); // Keep the plane at 1:1 scale
        clonedTexture.flipY = true; // Fix the flipped texture
        clonedTexture.needsUpdate = true;
        return clonedTexture;
    }, [originalTexture]);

    return (
        <TransformControls
            object={groupRef}
            mode="translate"
            camera={camera}
            domElement={gl.domElement}
        >
            <group 
                ref={groupRef} 
                position={[-(modelSize / 4) + 0.28, 0, modelDimensionZ * 1.1]}
                rotation={[-Math.PI / 2, 0, 0]}
            >
                <mesh position={[0, 0, 0]}>
                    <planeGeometry args={[1, 1]} />
                    <meshStandardMaterial map={texture} />
                    <Text
                        position={[0, -0.6, 0]}
                        fontSize={0.05}
                        color="black"
                        textAlign="center"
                    >
                        {"100 x 100 cm\n1024 x 1024 px"}
                    </Text>
                </mesh>
            </group>
        </TransformControls>
    );
}